import { cn } from "@/utils/shadcn-ui";

/**
 * Small purple count pill overhanging a button's top corner — active filters,
 * unsaved rows. The host button needs `relative`. Values `<= 0` render nothing.
 *
 * Hidden from assistive tech so the button keeps a stable accessible name — spell
 * the count out in the button's `title` or `aria-label`.
 */
export function CountBadge({
  count,
  align = "left",
  className,
}: {
  count?: number;
  /** Which top corner the pill hangs off. */
  align?: "left" | "right";
  className?: string;
}) {
  if (!count || count <= 0) return null;
  return (
    <span
      aria-hidden
      className={cn(
        // The pill overhangs onto the page, so a page-coloured ring keeps it
        // legible against both it and the button, in either theme.
        "absolute -top-2 inline-flex h-4.5 min-w-4.5 items-center justify-center rounded-full bg-brand-primary px-1 text-2xs font-bold text-white ring-2 ring-background",
        align === "left" ? "-left-2" : "-right-2",
        className,
      )}
    >
      {count}
    </span>
  );
}
